// @noflow
import type { Action } from './types';
import type { ThunkAction } from '../types';
import { getJson, postJson } from '../utilities/fetchUtils';

export const receiverCanRecord = receiverModel => {
  const incapableReceivers = [
    'VIP211Z',
    'VIP211',
    'VIP211K',
    'VIP222K',
    'VIP222',
    '311',
    '311K',
    '322',
  ];
  if (incapableReceivers.includes(receiverModel)) {
    return false;
  }
  return true;
};

export const appError = (error: Object): Action => ({
  type: 'APP_ERROR',
  payload: { error },
});

export const appViewportChanged = (viewport: {| width: number, height: number |}): Action => ({
  type: 'APP_VIEWPORT_CHANGED',
  payload: {
    ...viewport,
    landscape: viewport.width >= viewport.height,
    portrait: viewport.width < viewport.height,
  },
});

export const appOnline = (online: boolean): Action => ({
  type: 'APP_ONLINE',
  payload: { online },
});

export const appShowMenu = (menuShown: boolean): Action => ({
  type: 'APP_SHOW_MENU',
  payload: { menuShown },
});

export const toggleBaseline = (): Action => ({
  type: 'TOGGLE_BASELINE',
});

export const toggleFloatingTvRemoteView = (): Action => ({
  type: 'TOGGLE_FLOATING_TV_REMOTE_VIEW',
});

export const hideFloatingTvRemoteView = (): Action => ({
  type: 'HIDE_FLOATING_TV_REMOTE_VIEW',
});

export const tvRemoteKeyPress = (keyNames: string, receiverId: string): ThunkAction => ({
  getState,
  dispatch,
}) => {
  const state = getState();
  const url = `${state.config.session.radish_url}remote_control.json`;
  const headers = { Accept: 'application/vnd.echostar.remote_control+json;version=1' };
  const data = { key_names: keyNames, receiver_id: receiverId };

  dispatch({ type: 'REQUEST_TV_REMOTE_ACTION' });

  return postJson({ url, headers, state, data })
    .then(() => dispatch({ type: 'REQUEST_TV_REMOTE_ACTION_SUCCESS', keyNames: data.key_names }))
    .catch(error => {
      console.warn('tvRemoteKeyPress error', error);
      dispatch({ type: 'REQUEST_TV_REMOTE_ACTION_ERROR' });
    });
};

export const setTheme = (theme: string): Action => ({
  type: 'SET_THEME',
  payload: { theme },
});

export const setMobileTitle = (title: string): Action => ({
  type: 'SET_MOBILE_TITLE',
  payload: title,
});

export const changeActiveReceiver = (receiverId: string, nickname: string): ThunkAction => ({
  getState,
  dispatch,
}) => {
  const state = getState();
  const url = `${
    state.config.session.radish_url
  }v20/dol/users/change_active_receiver/7.json?receiver_id=${receiverId}`;
  dispatch({ type: 'CHANGE_ACTIVE_RECEIVER' });
  return getJson({ url, state })
    .then(data => {
      dispatch({
        type: 'CHANGE_ACTIVE_RECEIVER_SUCCESS',
        receiverId,
        nickname,
        state: data.state,
        model: data.model,
        canRecord: receiverCanRecord(data.model),
        finderId: data.finder_id ? data.finder_id.replace(/[.]/g, '') : undefined,
        slingAdmin: data.sling_admin_pw,
        zipCode: data.zip_code,
        stbSoftwareVersion: data.stb_software_version,
        stbUtcOffset: data.local_offset,
      });
    })
    .catch(error => {
      console.warn('changeActiveReceiver error', error);
      dispatch({ type: 'CHANGE_ACTIVE_RECEIVER_ERROR', error });
    });
};
